<script setup lang="ts">
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import BankingTaxCodesWorkspace from '@/views/Banking/TaxCodes/BankingTaxCodesWorkspace.vue'

definePage({
  meta: { ...PageMeta.Banking.TaxCodes.Meta, pageTitle: PageMeta.Banking.TaxCodes.Title },
})
</script>

<template>
  <BankingTaxCodesWorkspace />
</template>
